<template>
  <div>
    <div class="toubu">
      <div class="cont">
        <div class="newBox">
          <div class="iconfont icon-tuding tuding"></div>
          <div class="iconfont icon-tuding tuding1"></div>
          <div class="name">NEW</div>
          <div class="text">最新招聘会</div>
        </div>
        <div class="nrBox">
          <div class="name c-1">{{ infoData.name }}</div>
          <div class="text">欢迎企业报名参会，求职者来招聘会现场应聘</div>
          <div class="text">报名截至时间：{{ infoData.jiezhi }}</div>
          <div class="text">招聘会时间：{{ infoData.bmshijian }}</div>
          <div class="text">举办地址：{{ infoData.address }}</div>
          <div class="btn dis-cent" @click="jump(infoData.id)">查看详情</div>
        </div>
        <!-- <div class="img">
          <img :src="$imgUrl + infoData.resources[0].path_name" alt="" />
        </div> -->
      </div>
    </div>
    <div class="content">
      <div class="contentRit">
        <div class="headBox">
          <div class="name">招聘会列表</div>
          <!-- <div class="cont">
            <a-dropdown>
              <div class="box">
                <div class="text">
                  {{ category_cn == "全部状态" ? "全部状态" : "" }}
                </div>
                <div class="iconfont icon-enter"></div>
              </div>
              <a-menu
                slot="overlay"
                @click="hyClick"
                :selectedKeys="[category_id]"
              >
                <a-menu-item :key="item.id" v-for="item in xzList">{{
                  item.name
                }}</a-menu-item>
              </a-menu>
            </a-dropdown>
          </div> -->
        </div>
        <div class="contBox">
          <div class="cont" v-for="item in list">
            <div class="box">
              <div class="img">
                <img
                  :src="
                    item.resources ? $imgUrl + item.resources[0].path_name : ''
                  "
                  alt=""
                />
              </div>
              <div class="textBox">
                <div class="name" @click="jump(item.id)">{{ item.name }}</div>
                <div class="text">{{ item.address }}</div>
              </div>
            </div>
            <div class="timeBox">{{ item.start_time }}</div>
            <div class="ztBox">
              <div class="yuan"></div>
              <div class="text">{{ item.time ? "未召开" : "已结束" }}</div>
            </div>
            <div class="yyBox dis-cent">
              <div
                class="btn dis-cent"
                v-if="item.time"
                @click="yyClick(item.id)"
              >
                立即预约
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  message,
} from "ant-design-vue";
import Zprili from "./zprili.vue";

export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    Zprili,
  },
  name: "",
  data() {
    return {
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 30,
      },
      list: [],
      totalCount: 0,
      category_cn: "全部状态",
      category_id: "",
      xzList: [
        {
          id: "",
          name: "全部状态",
        },
        {
          id: "1",
          name: "未召开",
        },
        {
          id: "2",
          name: "已结束",
        },
      ],
      infoData: {},
    };
  },
  created() {
    this.listGet();
  },
  methods: {
    hyClick(e) {
      this.category_id = e.key;
      this.listGet();
      for (let i = 0; i < this.xzList.length; i++) {
        const ei = this.xzList[i];
        if (ei.subclass == e.key) {
          this.jobs_name = ei.jobs_name;
          this.$forceUpdate();
        }
      }
    },
    jump(id) {
      window.open("/#/gongsi/gsZhpCont?id=" + id);
    },
    yyClick(id) {
      window.open("/#/zhpMark?id=" + id);
      // this.$router.push({
      //   path: "/zhpMark",
      //   query: {
      //     id,
      //   },
      // });
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/recruit_gets", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          this.infoData = res.data[0];
          // this.infoData.bmshijian = this.$moment(res.data[0].start_time).format(
          //   "YYYY年MM月DD日"
          // );
          this.infoData.bmshijian =
            this.$moment(res.data[0].start_time).format(
              "YYYY年MM月DD日"
            ) +
            "~" +
            this.$moment(res.data[0].end_time).format("YYYY年MM月DD日");
          this.infoData.jiezhi = this.$moment(res.data[0].finish_time).format(
            "YYYY年MM月DD日"
          );
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            let date1 = this.$moment().format("YYYY-MM-DD");
            let date2 = this.$moment(e.start_time).format("YYYY-MM-DD");
            let time = this.$moment(date1).isBefore(date2);
            e.time = time;
            e.start_time = this.$moment(e.start_time).format(
              "YYYY年MM月DD日"
            );
            e.content = e.content
              .replace(/<[^<>]+>/g, "")
              .replace(/&nbsp;/gi, "")
              .replace(/\s/g, "");
          }
          console.log(this.infoData.bmshijian);

          this.list = res.data;
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.toubu {
  width: 100%;
  background-color: #fff;
  height: 230px;
  .cont {
    width: 1280px;
    margin: auto;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
    .newBox {
      width: 280px;
      height: 180px;
      border-radius: 10px;
      background-color: #0e6af2;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #fff;
      .tuding {
        position: absolute;
        top: 10px;
        left: 10px;
        color: #fff;
        font-size: 22px;
        transform: rotate(40deg);
      }
      .tuding1 {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 22px;
        transform: rotate(-40deg);
      }
      .name {
        font-weight: 600;
        font-size: 40px;
      }
      .text {
        font-size: 24px;
        margin-bottom: 7px;
      }
    }
    .nrBox {
      width: calc(100% - 280px);
      padding-left: 50px;
      box-sizing: border-box;
      height: 180px;
      position: relative;
      z-index: 2;
      .btn {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 140px;
        height: 50px;
        border-radius: 5px;
        background-color: #eb6206;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
      }
      .name {
        font-weight: 600;
        color: #0e6af2;
        font-size: 32px;
        margin-bottom: 10px;
      }
      .text {
        font-size: 16px;
        margin-bottom: 5px;
      }
    }
    .img {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
      height: 100%;
      width: 550px;
      img {
        object-fit: cover;
      }
    }
  }
}
.content {
  margin: auto;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  height: calc(100vh - 85px);
  width: 1280px;
  .contentLeft {
    width: 350px;
    border-right: 1px solid #ebebeb;
    .cont {
      height: 300px;
    }
    .text {
      color: #9c9c9c;
      padding: 10px 15px;
    }
  }
  .contentRit {
    // width: calc(100% - 350px);
    width: 100%;
    box-sizing: border-box;
    .headBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 70px;
      padding: 0 20px;
      .name {
        font-weight: 600;
        font-size: 20px;
      }
      .cont {
        display: flex;
        align-items: center;
        .box {
          margin-left: 20px;
          border-radius: 5px;
          background-color: #eef4fc;
          height: 35px;
          width: 150px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .text {
            width: calc(100% - 20px);
            padding-left: 12px;
            box-sizing: border-box;
          }
          .iconfont {
            font-size: 12px;
          }
        }
      }
    }
    .contBox {
      height: calc(100% - 70px);
      overflow: auto;
      box-sizing: border-box;
      padding: 0 20px 20px;
      .cont {
        display: flex;
        align-items: center;
        border: 1px solid #ebebeb;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 20px;
        .box {
          display: flex;
          flex: 1;
          .img {
            width: 120px;
            height: 80px;
            border-radius: 10px;
            overflow: hidden;
            img {
              object-fit: cover;
            }
          }
          .textBox {
            width: calc(100% - 120px);
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-sizing: border-box;
            padding-left: 10px;
            .name {
              font-weight: 600;
              font-size: 16px;
              cursor: pointer;
            }
            .text {
              color: #888;
            }
          }
        }
        .timeBox {
          width: 200px;
          text-align: center;
          font-size: 16px;
          color: #2a3d50;
          font-weight: 700;
        }
        .ztBox {
          width: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          .yuan {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: #1596ff;
            margin-right: 5px;
          }
        }
        .yyBox {
          width: 200px;
          .btn {
            width: 90px;
            height: 40px;
            border-radius: 5px;
            background-color: #1596ff;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
